import { render, staticRenderFns } from "./AddDictData.vue?vue&type=template&id=1649e3f4&scoped=true&"
import script from "./AddDictData.vue?vue&type=script&lang=js&"
export * from "./AddDictData.vue?vue&type=script&lang=js&"
import style0 from "./AddDictData.vue?vue&type=style&index=0&id=1649e3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1649e3f4",
  null
  
)

export default component.exports